import { render, staticRenderFns } from "./ProductDetailsMobile.vue?vue&type=template&id=ca1233b2&scoped=true"
import script from "./ProductDetailsMobile.vue?vue&type=script&lang=js"
export * from "./ProductDetailsMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsMobile.vue?vue&type=style&index=0&id=ca1233b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1233b2",
  null
  
)

export default component.exports